import React from 'react'

// import { HashRouter } from 'react-router-dom'
import ReactDOM from 'react-dom/client'
import '@/extends/CesiumView'
import App from './App'
import '@/assets/global.less'
import '@/assets/mobile.less'

ReactDOM.createRoot(document.getElementById('root')!).render(
  // Enabling strict mode causes useEffect to be executed twice in development mode.
  // <React.StrictMode>
  // <HashRouter>
      <App />,
  // </HashRouter>,
  // </React.StrictMode>,
)
